import script from "./FinalReview.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinalReview.vue?vue&type=script&setup=true&lang=ts"

import "./FinalReview.vue?vue&type=style&index=0&id=11830822&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11830822"]])

export default __exports__